import { logger } from '@/util/logger';

const {$} = window as any;

enum ToastType {
    Alert = 'alert',
    Confirm = 'confirm',
    Neutral = 'neutral'
}

class Toaster {
    public toasts = {};
    public settings: object;

    constructor (settings?: object) {
        this.settings = settings ? settings : {};

        $(() => {
            const $head = $('.js-head').length > 0 ? $('.js-head') : $('body');
            this.doToastWrapOffset($head);
            $(window).on('scroll', () => {
                // set toast wrap position. This will be 10px plus the amount of header pixels visible based on scroll position
                this.doToastWrapOffset($head);
            });
        });
    }

    private doToastWrapOffset = ($head: JQuery) => {
        $('.js-toast-wrap').css('top', Math.max($head.height() - $(window).scrollTop(), 0));
    }
}
const toaster = new Toaster();

class Toast {
    private id: string;
    private $outer: JQuery;
    private $text: JQuery;
    private $close: JQuery;
    private settings: any;
    private DISPLAY_TIME: number;
    private hideTimer?: ReturnType<typeof setTimeout>;

    constructor(id: string, settings: any) {
        toaster.toasts[id] = this;

        this.settings = settings || {};
        this.id = id;
        this.$outer = $(`#${  this.id}`);
        this.$text = this.$outer.find('.js-text');
        this.$close = this.$outer.find('.js-close');

        this.DISPLAY_TIME = 7000;
        this.hideTimer = null;

        if (!this.settings.type || Object.values(ToastType).indexOf(this.settings.type) < 0) {
            logger.log(`invalid "type" specified for Toast, ${  this.id  }. Valid types are "alert", "neutral", and "confirm"`);
            return;
        }

        $(() => {
            this.updateElements();
            this.attachEvents();
        });
    }

    private hide = () => {
        this.$outer
            .removeClass('animate')
            .delay(250)
            .queue(function() {
                $(this).removeClass('is-showing');
            })
            .dequeue();

        $(window).off(`.toast${  this.id}`);
    };

    private startHideTimer = (displayTime: string) => {
        if (displayTime === null) {
            return; 
        }

        let t = this.DISPLAY_TIME;
        if (parseInt(displayTime) > 0) {
            t = parseInt(displayTime);
        }

        this.hideTimer = setTimeout(() => {
            this.hide();
        }, t);
    };

    private cancelHideTimer = () => {
        clearTimeout(this.hideTimer);
    };

    private updateElements = () => {
        this.$outer = $(`#${  this.id}`);
        this.$text = this.$outer.find('.js-text');
        this.$close = this.$outer.find('.js-close');
    }

    private attachEvents = () => {
        if (this.$close.length > 0) {
            this.$close.off('click').on('click', () => {
                this.hide();
            });
        }
    }

    public show = (msg: string, displayTime?: string) => {
        if (!msg) {
            throw new Error('No message defined for Toast');
        }

        this.cancelHideTimer();
        this.updateElements();
        this.attachEvents();

        this.$outer
            .addClass('is-showing')
            .addClass('animate');

        this.$text.html(msg);

        this.startHideTimer(displayTime);
    };
}

const alertToast = new Toast('alertToast', {
    type: ToastType.Alert 
});
const confirmToast = new Toast('confirmToast', {
    type: ToastType.Confirm 
});
const neutralToast = new Toast('neutralToast', {
    type: ToastType.Neutral 
});

export {
    alertToast,
    confirmToast,
    neutralToast
};
